<template>
  <div class="blocks" @click="onClick">
    <template v-for="(block, index) in blocks" :key="index">
      <p v-if="block.p" v-html="format(block.p)"></p>
      <h3 v-else-if="block.h3" v-html="format(block.h3)"></h3>
      <ul v-else-if="block.ul">
        <li v-for="(item, i) in block.ul" :key="i" v-html="format(item)"></li>
      </ul>
      <ol v-else-if="block.ol">
        <li v-for="(item, i) in block.ol" :key="i" v-html="format(item)"></li>
      </ol>
      <div v-else-if="block.note" class="callout">
        <p v-html="format(block.note)"></p>
      </div>
      <figure v-else-if="block.figure" class="shot" :class="{'shot--narrow': block.figure.width < 600}">
        <img :src="block.figure.src" :width="block.figure.width" :height="block.figure.height" :alt="block.figure.alt" loading="lazy">
        <figcaption v-if="block.figure.caption" class="muted">{{ block.figure.caption }}</figcaption>
      </figure>
      <blockquote v-else-if="block.quote" class="draft">
        <p v-for="(paragraph, i) in block.quote.split('\n\n')" :key="i">{{ paragraph }}</p>
      </blockquote>
      <pre v-else-if="block.code" class="code"><code>{{ block.code }}</code></pre>
      <div v-else-if="block.table" class="table-wrap">
        <table>
          <thead>
            <tr><th v-for="(cell, i) in block.table.head" :key="i" scope="col">{{ cell }}</th></tr>
          </thead>
          <tbody>
            <tr v-for="(row, r) in block.table.rows" :key="r">
              <td v-for="(cell, c) in row" :key="c" class="tabular">{{ cell }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </template>
  </div>
</template>

<script>
  import {inline} from "@/seo/inline";
  import {followInternalLink} from "@/seo/internalLinks";

  /**
   * Affiche les blocs de contenu de src/content (paragraphes, listes, tableaux, encadrés, captures d'écran {figure}, modèle de message, extrait de code {code}).
   * Les liens internes passent par le routeur, sans recharger la page ; dans le HTML prérendu ce sont de simples liens.
   */
  export default {
    name: 'ContentBlocks',
    props: {
      blocks: {type: Array, required: true},
    },
    methods: {
      format(text) {
        return inline(text);
      },
      onClick(event) {
        followInternalLink(event, this.$router);
      },
    },
  }
</script>

<style lang="stylus" scoped>
@import '~/src/common/style/constants.styl';

.shot
  margin-left 0
  margin-right 0
  img
    display block
    width 100%
    height auto
    border 2px solid INK
    border-radius 4px
    background WHITE
  figcaption
    margin-top 10px
    font-size 0.9rem

// Capture haute et étroite (par exemple un panneau latéral) : on la limite en largeur
.shot--narrow img
  width auto
  max-width 100%

// Extrait de code (XML d'une facture Factur-X, par exemple)
.code
  margin 1.4em 0
  padding 18px 22px
  background WHITE
  border 2px solid INK
  border-radius 4px
  overflow-x auto
  font-family ui-monospace, SFMono-Regular, Menlo, Consolas, monospace
  font-size 0.85rem
  line-height 1.55
  color INK
  white-space pre

.draft
  margin-left 0
  padding 18px 22px
  background WHITE
  border 1px dashed MUTED
  border-radius 4px
  font-size 1rem
  color INK_SOFT
  p
    margin 0
  p + p
    margin-top 0.8em
</style>
